import { render, staticRenderFns } from "./PersonalInfoStep.vue?vue&type=template&id=995d187a"
import script from "./PersonalInfoStep.vue?vue&type=script&lang=ts"
export * from "./PersonalInfoStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports